import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type SupplierActivationRequestsResponse } from './types';
import { zodSupplierActivationRequestsResponseSchema } from './validations';

/**
 * Fetches all activation requests for a data-exchange, ordered newest first.
 *
 * @param deId - The data-exchange ID.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The list of activation requests.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/get_activation_requests_for_de_suppliers__de_id__activation_requests_get
 */
export const fetchSupplierActivationRequests = async (
  deId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.SUPPLIER.GET_ACTIVATION_REQUESTS(deId), {
      ...options,
      validate: {
        ...options?.validate,
        response: zodSupplierActivationRequestsResponseSchema,
      },
    })
    .json<SupplierActivationRequestsResponse>();
